document.addEventListener("DOMContentLoaded", function (event) {

    let images_product = document.querySelector('.footer-block__list-payment ul');
    console.log("images_product ", images_product)
    let imageProduct = document.querySelector('.new-list-image')
    if (imageProduct && images_product) {
      imageProduct.innerHTML = images_product.innerHTML.trim().replace(/:/g, '');
    }

    let isScrolling = false;

    const productSection = document.querySelectorAll(".product-section");
    // 获取所有区域和锚链接
    const sections = document.querySelectorAll(".scroll-section");
    const navLinks = document.querySelectorAll(".new-tab-title");
    const navBar = document.querySelector(".new-productView-bar")
    // 创建一个包含每个区域的 offset top 的数组
    const sectionOffsets = Array.from(sections).map(
        (section) => section.offsetTop
    );
    let lastScrollTop = 0;

    function updateNav() {
        if (isScrolling) return;
        isScrolling = true;
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const direction = currentScrollTop > lastScrollTop ? 'down' : 'up';
        lastScrollTop = currentScrollTop;
        // 获取当前滚动位置
        const scrollPosition = window.scrollY;

        // 循环遍历每个区域的 offsetTop 并检查哪个区域正在视图中
        sectionOffsets.forEach((offset, index) => {
            const offsetTop = sections[index].offsetTop;
            const sectionHeight = sections[index].offsetHeight;
            const isInView =
                scrollPosition >= offset - 60 && scrollPosition < offset + sectionHeight;
            // console.log("offset + sectionHeight: ", offset + sectionHeight, "scrollPosition: ", scrollPosition, "offset: ", offset, "sectionHeight: ", sectionHeight)
            // 如果一个区域正在视图中，就高亮对应的导航链接
            // if (isInView) {
            //     navLinks.forEach((link) =>
            //         link.classList.remove("custom_active")
            //     );
            //     navLinks[index].classList.add("custom_active");
            // }
        });
        setTimeout(() => isScrolling = false, 500);
    }

    window.addEventListener("scroll", () => {
        updateNav();
    });

    const new_product_tab = document.querySelectorAll(".new-tab-heading .new-tab-title span");
    new_product_tab.forEach((e) => {
        e.onclick = function () {
            new_product_tab.forEach((a) => {
                a.classList.remove("custom_active")
            })
            e.classList.add("custom_active");
            isScrolling = true;
            setTimeout(() => {
                updateNav();
                isScrolling = false;
            }, 1000);
        }
    })

    const purchase_tab = document.getElementById('new-product-purchase-tab');
    if (purchase_tab) {
        const purchase_content = document.querySelector('.product-details');
        if (purchase_content) {
            const purchaseOffsetTop = purchase_content.offsetTop - 20;

            if (purchase_tab) {
                purchase_tab.addEventListener("click", function (e) {
                    window.scrollTo({
                        top: purchaseOffsetTop,
                        behavior: "smooth"
                    });
                    setTimeout(() => updateNav(), 1000);
                });
            }
        }


        const faq_tab = document.getElementById('new-product-table-tab');
        const faq_content = document.querySelector('yg-faq');
        // if(faq_content) {
        //     const faqOffsetTop = faq_content.offsetTop - 60;
        //      if (faq_tab) {
        //     faq_tab.addEventListener("click", function (e) {
        //         window.scrollTo({
        //             top: faqOffsetTop,
        //             behavior: "smooth"
        //         });
        //     });
        //     }
        // }


        if (faq_tab) {
            faq_tab.addEventListener("click", function (e) {
                // 点击 backtop，跳转到 d3 的位置
                faq_content.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });

                e.preventDefault();
            });
        }


        const table_tab = document.getElementById('new-product-overview-tab');
        const table_content = document.querySelector('yg-specifications');
        // console.log("table_content: ", table_content);
        // if(table_content) {
        //     const tableOffsetTop = table_content.offsetTop - 60;
        //     if (table_tab) {
        //     table_tab.addEventListener("click", function (e) {
        //         window.scrollTo({
        //             top: tableOffsetTop,
        //             behavior: "smooth"
        //         });
        //         setTimeout(() => updateNav(), 1000);
        //     });
        //     }
        // }


        if (table_tab) {
            table_tab.addEventListener("click", function (e) {
                // 点击 backtop，跳转到 d3 的位置
                table_content.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });

                e.preventDefault();
            });
        }

        //零件导航
        // const accessories_purchase_content = document.querySelector('.product-details');
        // const accessories_purchaseOffsetTop = purchase_content.offsetTop - 20;

        //  if (purchase_tab) {
        //     purchase_tab.addEventListener("click", function (e) {
        //         window.scrollTo({
        //             top: accessories_purchaseOffsetTop,
        //             behavior: "smooth"
        //         });
        //         setTimeout(() => updateNav(), 1000);
        //     });
        // }

        // const accessories_faq_tab = document.getElementById('new-product-table-tab');
        // const accessories_faq_content = document.getElementById('faq-tab');
        // const accessories_faqOffsetTop = faq_content.offsetTop - 60;


        // const accessories_table_tab = document.getElementById('new-product-overview-tab');
        // const accessories_table_content = document.querySelector('.new-table-tab');
        // const accessories_tableOffsetTop = table_content.offsetTop - 60;

        // const accessories_review_tab = document.getElementById('new-product-reviews-tab');
        // const accessories_review_content = document.getElementById('judgeme_product_reviews');
        // const accessories_reviewOffsetTop = review_content.offsetTop - 60;


        // const faq_tab = document.getElementById('new-product-faqs-tab');
        // const faq_content = document.getElementById('new-product-reviews');
        // const faqOffsetTop = faq_content.offsetTop - 100;

        const review_tab = document.getElementById('new-product-reviews-tab');
        const review_content = document.getElementById('judgeme_product_reviews');
        // if(review_content) {
        //     const reviewOffsetTop = review_content.offsetTop - 60;
        //      if (review_tab) {
        //     review_tab.addEventListener("click", function (e) {
        //         window.scrollTo({
        //             top: reviewOffsetTop,
        //             behavior: "smooth"
        //         });
        //         console.log("nihao")
        //         setTimeout(() => updateNav(), 1000);
        //     });
        // }
        // }

        if (review_tab) {
            review_tab.addEventListener("click", function (e) {
                // 点击 backtop，跳转到 d3 的位置
                review_content.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });

                e.preventDefault();
            });
        }


        const spec_tab = document.getElementById('new-product-overview-tab');
        const spec_content = document.querySelector('.yg-custom-table');
        // if(faq_content) {
        //     const specOffsetTop = spec_content.offsetTop - 0;
        //      if (spec_tab) {
        //     spec_tab.addEventListener("click", function (e) {
        //         window.scrollTo({
        //             top: specOffsetTop,
        //             behavior: "smooth"
        //         });
        //     });
        //     }
        // }


        if (spec_tab) {
            spec_tab.addEventListener("click", function (e) {
                console.log("spec_content:", spec_content)
                // 点击 backtop，跳转到 d3 的位置
                spec_content.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });

                e.preventDefault();
            });
        }
        // if (overview_tab) {
        //     overview_tab.addEventListener("click", function (e) {
        //         window.scrollTo({
        //             top: overviewOffsetTop,
        //             behavior: "smooth"
        //         });
        //         setTimeout(() => updateNav(), 1000);
        //     });
        // }


    }

})